import { render, staticRenderFns } from "./SavedToWorkspacePopper.vue?vue&type=template&id=76155fed"
import script from "./SavedToWorkspacePopper.vue?vue&type=script&lang=ts"
export * from "./SavedToWorkspacePopper.vue?vue&type=script&lang=ts"
import style0 from "./SavedToWorkspacePopper.vue?vue&type=style&index=0&id=76155fed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports